import React from "react";
import styles from "./style.module.scss";
import { UIText } from "src/components/uIKit";
import { MustListBodyList } from "src/utils/types";
import { TEXT_TAGS } from "src/utils/enums";
import { Separator } from "..";
import { useIsMobile } from "src/hooks/useIsMobile";

interface MustListContentProps {
  title?: string;
  subTitle?: string;
  image?: string;
  body?: string;
  bodyList?: MustListBodyList[];
}

const MustListContent = ({
  title,
  subTitle,
  image,
  body,
  bodyList,
}: MustListContentProps) => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.representativeWrapper}>
      {title && (
        <UIText
          text={title}
          tag={TEXT_TAGS.H1}
          size={isMobile ? 18 : 40}
          weight={600}
          style={styles.representativeSubTitle}
        />
      )}
      <Separator className={styles.separator} />

      {subTitle && (
        <UIText
          text={subTitle}
          size={28}
          weight={500}
          style={styles.representativeSubTitle}
        />
      )}
      <div>
        {bodyList &&
          bodyList.map((item, index) => (
            <div key={index} className={styles.representativeBodyList}>
              <div>
                <UIText
                  text={item.title}
                  size={18}
                  weight={400}
                  style={styles.representativeText}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default MustListContent;
